import { createContext } from 'react';

export const PrintValuesContext = createContext({});

export default PrintValuesContext;
